if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
            this.getCartItems();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('.cart-item').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
                	remove.dataset.href = remove.getAttribute('href');
    				remove.setAttribute('href', '');
    				remove.addEventListener('click', (e)=>{
    					e.preventDefault();
    					this.updateCartQty(item, 0);
    				})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){
            if (typeof BSS_B2B === 'object') {
                const checkoutButton = document.querySelector("#bss-checkout")
                if (checkoutButton && checkoutButton.getAttribute('bss_b2b_button_checkout')) {
                    checkoutButton.style.opacity = '0.6'
                    checkoutButton.style.pointerEvents = 'none'
                }
            }

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				id: item.dataset.id,
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						// wrong stock logic alert
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

                    /*-------- Rajout Eric -----------------------------------*/
                    window. ExtendCartLabels();
                    /*-------- Rajout Eric -----------------------------------*/   
                  
					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					if (typeof BSS_B2B === 'object') {
                      if (typeof BSS_B2B === 'object' && BSS_B2B?.cart?.fixer && BSS_B2B?.handleCartCheckoutBtn) {
                        BSS_B2B.cart.fixer(BSS_B2B.shopData, false, false)
                      }
                      BSS_B2B.handleCartCheckoutBtn(JSON.parse($('#bss-b2b-store-data').html()))
                      const checkoutButton = document.querySelector("button[type='submit']")
                      if (checkoutButton) {
                          checkoutButton.style.opacity = '0.6'
                          checkoutButton.style.pointerEvents = 'none'
                          setTimeout(() => {
                             checkoutButton.style.opacity = '1'
                            checkoutButton.style.pointerEvents = 'unset'
                          },2000)
                      }
                    }  
					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

      getCartItems() {
          fetch('/cart.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
          .then(response => response.json())
          .then(data => {
            this.updateNextCustomerProperty(data.items, 0);
          })
          .catch(error => {
            console.error('Error fetching cart data:', error);
          });
      }

    updateNextCustomerProperty(items, index) {
      if (index >= items.length) return; // Exit if no more items
    
      let item = items[index];
      let needsUpdate = false;
    
      if (customerTags.includes('b2b') && !item.properties._customer) {
        item.properties._customer = 'b2b';
        needsUpdate = true;
      } else if (!customerTags.includes('b2b') && item.properties._customer) {
        delete item.properties._customer;
        needsUpdate = true;
      }

      if (needsUpdate) {
        const body = JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: item.properties
        });
    
        fetch(KROWN.settings.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body
        })
        .then(response => response.json())
        .then(data => {
          // Fetch the cart again to get updated items and continue updating the next one
          fetch('/cart.js', {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            }
          })
          .then(response => response.json())
          .then(updatedData => {
            this.updateNextCustomerProperty(updatedData.items, index + 1);
          })
          .catch(error => {
            console.error('Error fetching updated cart data:', error);
          });
        })
        .catch(error => {
          console.error('Error updating cart item:', error);
        });
      } else {
        // Continue with the next item if no update is needed
        this.updateNextCustomerProperty(items, index + 1);
      }
    }



	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

		})

	}

}

if ( ! window.updateQtyCart ) {

	window.updateQtyCart = (btnLoading, closeModalBtnCloseCart) => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			//if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
			//	document.querySelector('[data-js-site-cart-sidebar]').show();
			//}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

            if(btnLoading){
              var modal = document.getElementById("my-modal");
              modal.style.display = "none";
              document.querySelector(".mount-header").classList.remove("removeIndex");
              document.querySelector(".shopify-section-group-header-group:has(.breadcrumb)").classList.add("removeIndex");
              document.querySelector("#go-top").classList.remove("removeIndex");
              //document.querySelector(".bss-currency-wrapper").classList.remove("removeIndex");
              document.querySelector("body").classList.remove("removeScrollHeight");

              if(closeModalBtnCloseCart){
                if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
                  document.querySelector('[data-js-site-cart-sidebar]').show();
                }
              }
            }
            document.getElementById("add-products-in-bulk").classList.remove('loading');

		})

	}

}